import moment from "moment";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CalendarIcon from "@mui/icons-material/EditCalendar";

import Card from "@cobComponents/Card";
import ButtonAdd from "@components/ButtonAdd/ButtonAdd";

import useCrmEventsCard from "./useCrmEventsCard";
import CrmEvent from "./CrmEvent";
import EditEventModal from "./EditEventModal";

const CrmEventsCard = props => {
  const {
    loaded,
    client,
    events,
    selectedEvent,
    updateEvents,
    editEventModalOpen,
    toggleEditEventModal
  } = useCrmEventsCard(props);

  return (
    <Card
      title="Kundaktivitet"
      icon={CalendarIcon}
      loading={!loaded}
      sxStyle={{
        width: "100%",
        maxWidth: "unset",
        mt: { xs: 2, md: 0 }
      }}
    >
      <Box
        sx={{
          height: 0,
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          top: -31
        }}
      >
        <ButtonAdd
          label="Ny aktivitet"
          onClick={() => toggleEditEventModal("add")}
        />
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          mt: 0.6
        }}
      >
        {events.active?.length > 0 &&
          events.past.map(event => {
            // If an event ended and the event Attended is "unknown", it needs action
            const needsAction =
              moment(event.EndTime).isBefore(moment()) &&
              event.Attended === "unknown";

            return needsAction ? (
              <CrmEvent
                key={event.EventId}
                event={event}
                past={true}
                updateEvents={updateEvents}
              />
            ) : null;
          })}
        <Typography
          sx={{
            fontFamily: "Lato",
            fontSize: "15px",
            fontWeight: 600,
            color: "common.black",
            lineHeight: 0.9
          }}
        >
          Kommande
        </Typography>
        {events.active?.length > 0 ? (
          events.active.map(event => (
            <CrmEvent
              key={event.EventId}
              event={event}
              past={false}
            />
          ))
        ) : (
          <Typography
            sx={{
              fontFamily: "Lato",
              fontSize: "14px",
              color: "text.secondary",
              mt: 1
            }}
          >
            Inga kommande aktiviteter hittades
          </Typography>
        )}
        <Typography
          sx={{
            fontFamily: "Lato",
            fontSize: "15px",
            fontWeight: 600,
            color: "common.black",
            lineHeight: 0.9,
            mt: 2
          }}
        >
          Genomförda
        </Typography>
        {events.past?.length > 0 ? (
          events.past.map(event => {
            
            return event.Attended !== "unknown" ? (
              <CrmEvent
                key={event.EventId}
                event={event}
                past={true}
              />
            ) : null;
          })
        ) : (
          <Typography
            sx={{
              fontFamily: "Lato",
              fontSize: "14px",
              color: "text.secondary",
              mt: 1
            }}
          >
            Inga genomförda aktiviteter hittades
          </Typography>
        )}
      </Box>
      {editEventModalOpen && (
        <EditEventModal
          open={editEventModalOpen}
          client={client}
          event={selectedEvent}
          updateEvents={updateEvents}
          toggle={toggleEditEventModal}
        />
      )}
    </Card>
  );
};

export default CrmEventsCard;
